export default __webpack_public_path__ + "static/media/TNS-Web-Banners3.7404a135.png";